import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { any } from 'util/arrays'
import { Label, Loader } from 'shared/ui'

import {
  doFetchLinearIssues,
  selectCurrentTicketLinkedIssues,
} from 'ducks/integrations/linear'

function getLinearIssueKey({ identifier, url }) {
  if (identifier) return identifier
  const match = url && url.match(/\/issue\/([^/?#]+)/i)
  return match && match[1]
}

export default function LinkedLinearIssues({ doNavigatableSetState }) {
  const dispatch = useDispatch()
  const issues = useSelector(selectCurrentTicketLinkedIssues)
  const issueRefs =
    issues && issues.map(({ externalId, id }) => externalId || id)
  const issueRefsSerialized = JSON.stringify(issueRefs)
  const handleIssueClick = useCallback(
    issueKey => () => doNavigatableSetState(issueKey),
    [doNavigatableSetState]
  )

  useEffect(
    () => {
      if (issueRefs) dispatch(doFetchLinearIssues(issueRefs))
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, issueRefsSerialized]
  )

  if (!issues || issues.length === 0) return null
  const isLoaded = any(({ loaded }) => loaded, issues)

  return (
    <>
      <Label size="small">Linked Issues ({issues.length})</Label>
      <NavigatableIntegrationWidgetCard.List>
        {!isLoaded && <Loader />}
        {isLoaded &&
          issues.map(issue => {
            if (!issue) return null
            const { id, externalId, identifier, state, title } = issue
            const workflowState = issue.workflowState || state || {}
            const issueKey = id || externalId || identifier
            const humanIssueKey = getLinearIssueKey(issue)
            let subTitleStatus = 'neutral'
            if (workflowState.type === 'completed') subTitleStatus = 'success'
            if (workflowState.type === 'canceled') subTitleStatus = 'negative'
            return (
              <NavigatableIntegrationWidgetCard.ListItem
                key={issueKey}
                onClick={handleIssueClick(issueKey)}
                subTitle={humanIssueKey}
                subTitleStatus={subTitleStatus}
                subTitleStatusText={workflowState.name}
                title={title || humanIssueKey || 'Linear issue'}
              />
            )
          })}
      </NavigatableIntegrationWidgetCard.List>
    </>
  )
}
